import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function G() {
    const { t } = useLang('bkw');
    return (
        <div id="bkw-G" className={`bkw-G bkw-box ${css['bkw-G']}`}>
            <EfSpec />
            <div className="img-box">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1738834771922/6.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1739839830943/6_M.jpg"
                />
                <div className="info">
                    <h2 className="title">
                        {t.rich('G_title', {
                            y: (tx: string) => <span className="y">{tx}</span>,
                        })}
                    </h2>
                    <p className="desc">{t('G_desc')}</p>
                </div>
            </div>
        </div>
    );
}
